import { IFetchConfig } from "@elsa-zku/lib/helpers/fetch";
import fetch from "./http-client";

import { UsersApartments } from "./data-contracts";

export const getAppLegacyUsersapartmentsGetownersandmanagers = (id: number, params?: IFetchConfig) =>
  fetch<UsersApartments[]>("GET", `apartments/${id}/account`, null, params);
